import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from 'components/common/IconButton';
import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { ButtonGroup, Card, Col, Form, Row, Spinner, Table, ToggleButton } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useToast } from 'context/providers/ToastProvider';
import Select from 'react-select';

const NuevoCliente = () => {

    const navigate = useNavigate();
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();

    const [tablaRegimenFiscal, settablaRegimenFiscal] = useState([]);
    const [tablaUsoCFDI, settablaUsoCFDI] = useState([]);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [codigosPaises, setCodigosPaises] = useState([]);
    const [distribuidores, setDistribuidores] = useState([]);

    const [cargando, setCargando] = useState(true);
    const [cargandoEstado, setCargandoEstado] = useState(false);
    const [editar, setEditar] = useState(true);
    const [isExtranjero, setIsExtranjero] = useState(false);
    const [isDistribucion, setIsDistribucion] = useState(false);


    const obtenerComboBoxes = async () => {
        setCargando(true);
        setCountries([]);
        const response = await fetch("/api/cliente/getcomboboxes", {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);

            });

        if (response.ok) {
            console.log(response);
            const data = await response.json();

            console.log(data['table1']);
            settablaRegimenFiscal(data['table1']);

            console.log(data['table2']);
            settablaUsoCFDI(data['table2']);

            console.log(data['table3']);
            setCountries(data['table3']);


        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setCargando(false);

    };

    const obtenerCatalogosPaises = async () => {
        const response = await fetch("/api/Facturas/ObtenerCatPaises", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error);
            });

        if (response.ok) {
            const data = await response.json();
            if (data.iResponseType === 1) {
                const parsedData = JSON.parse(data.detalles);
                setCodigosPaises(parsedData.table2 || []);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    const obtenerDistribuidores = async () => {
        const response = await fetch("/api/cliente/GetDistribuidores", {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error);
            });

        if (response.ok) {
            const data = await response.json();
            const table = data.table2  || [];
            setDistribuidores(table);
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    const mostrarEstados = async (e) => {
        setCargandoEstado(true);
        setStates([]);
        setValue("vEstadoDepProv", "");
        // Detectar si el país es México usando la misma lógica existente
        const esMexico = e.includes('XICO');
        if (esMexico) {
            setValue("vRfc", "XAXX010101000");
            setValue("idCatRegimenFiscal", 12);
            setValue("idCatUsoCFDI", 22);
            setIsExtranjero(false);
            // Para México limpiar país de facturación
            setValue('vPaisFacturacion', '');
        }
        else {
            setValue("vRfc", "XEXX010101000");
            setValue("idCatRegimenFiscal", 12);
            setValue("idCatUsoCFDI", 22);
            setIsExtranjero(true);

            // Si el país seleccionado no es México, intentar asignar automáticamente
            // el código corto del país para el campo de facturación usando la
            // lista `codigosPaises` (valor `cShortName`). Si no se encuentra, limpiar.
            try {
                const found = codigosPaises.find(p => p.vName && p.vName.toUpperCase() === e.toUpperCase());
                if (found && found.cShortName) {
                    setValue('vPaisFacturacion', found.cShortName);
                } else {
                    setValue('vPaisFacturacion', '');
                }
            } catch (err) {
                // Si ocurre cualquier error, no bloquear el flujo; limpiar el valor
                setValue('vPaisFacturacion', '');
            }
        }
        setValue('vCp', '61770');


        console.log(e);
        const response = await fetch("/api/cliente/GetStatesByCountry/?vCountryName=" + encodeURIComponent(e), {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error.message);
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {
            console.log(response);
            const data = await response.json();

            console.log(data);
            setStates(data);
            setCargandoEstado(false);


        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            setStates([]);
            console.log(response);
            setCargandoEstado(false);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }

    };

    const enviarInfoToServer = async (data) => {
        setCargando(true);
        console.log(data);
        console.log(JSON.stringify({ values: data }));
        const response = await fetch("/api/cliente/GuardarCliente?values=" + encodeURIComponent(data),
            {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: data
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
                setCargando(false);
            });

        if (response.ok) {
            console.log("response: ", response);

            const data = await response.json();
            console.log("data: ", data);

            if (data.iResponseType == 1) {

                //const detalles = data.detalles;
                var detalles = JSON.parse(data.detalles);

                console.log("detalles: ", detalles);

                setCargando(false);
                setEditar(false);
                navigate("/clientes/detalle/" + detalles["table2"][0].idClienteAkasia);
            }
            

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            setStates([]);
            console.log(response);
            setCargando(false);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }

    };

    const onSubmit = data => {
        enviarInfoToServer(JSON.stringify(data, null, 2));
    };

    useEffect(() => {
        obtenerComboBoxes();
        obtenerCatalogosPaises();
        obtenerDistribuidores();
    }, []);

    return (
        <>
            <Card className="mb-1 p-2">
                <Row className="g-2 align-items-sm-center">
                    <Col xs="auto">
                        <IconButton
                            onClick={() => navigate(-1)}
                            variant="falcon-default"
                            size="sm"
                            icon="arrow-left"
                        />
                    </Col>
                    <Col>
                        <h5>
                            Nuevo cliente
                        </h5>
                    </Col>
                </Row>
            </Card>
            {cargando &&
                (
                    <h6>
                        <Spinner className="text-inline" animation="border" variant="primary" /> Cargando...
                    </h6>
                )}
            <Form noValidate onSubmit={handleSubmit(onSubmit)}>
                <Row className="mt-1">
                    <Col lg={6}>
                        <Card>
                            <Card.Header className="p-2">
                                <h6 className="fw-semi-bold text-uppercase">
                                    <FontAwesomeIcon icon="phone" className="mx-2" /> INFORMACI&Oacute;N DE CONTACTO
                                </h6>
                            </Card.Header>
                            <Card.Body className="border-top">

                                <Table responsive striped size="sm" className="fs--1" >
                                    <tbody>
                                        <tr>
                                            <td > <strong>Nombre </strong></td>
                                            <td>
                                                <Form.Control
                                                    type="hidden"
                                                    defaultValue={0}
                                                    {...register("idClienteAkasia")}
                                                />
                                                <Form.Control
                                                    type="text"
                                                    size="sm"
                                                    onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}

                                                    autoComplete="off"
                                                    id="vNombre"
                                                    isInvalid={!!errors.vNombre}
                                                    {...register("vNombre",
                                                        {
                                                            required: 'El nombre del cliente es requerido',
                                                            maxLength: 100,
                                                            minLength: 1
                                                        })
                                                    }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.vNombre && errors.vNombre.message}
                                                </Form.Control.Feedback>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong>Apellidos</strong>
                                            </td>
                                            <td>
                                                <Form.Control
                                                    type="text"
                                                    size="sm"
                                                    onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                    id="vApellidos"
                                                    autoComplete="off"
                                                    isInvalid={!!errors.vApellidos}
                                                    {...register("vApellidos",
                                                        {
                                                            required: 'Los apellidos son requeridos',
                                                            maxLength: 100,
                                                            minLength: 1
                                                        })
                                                    }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.vApellidos && errors.vApellidos.message}
                                                </Form.Control.Feedback>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td> <strong>Email </strong></td>
                                            <td>
                                                <Form.Control
                                                    type="text"
                                                    size="sm"
                                                    autoComplete="off"
                                                    isInvalid={!!errors.vEmail}
                                                    {...register("vEmail",
                                                        {
                                                            required: 'El email es requerido',
                                                            maxLength: 120,
                                                            minLength: 5,
                                                            pattern: {
                                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                                message: "Email incorrecto."
                                                            }
                                                        })
                                                    }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.vEmail && errors.vEmail.message}
                                                </Form.Control.Feedback>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="col-lg-4 col-sm-4 col-md-4">
                                                <strong>Tipo Cliente</strong>
                                            </td>
                                            <td>
                                                {editar ?
                                                    (
                                                        <Form.Select
                                                            defaultValue={"1"}
                                                            size="sm"
                                                            aria-label="Default select"
                                                            {...register("idCatTipoCliente",
                                                                {
                                                                    required: true
                                                                })
                                                            }
                                                        >
                                                            <option value="1">CONSUMIDOR FINAL</option>
                                                            <option value="2">DISTRIBUIDOR</option>
                                                        </Form.Select>
                                                    ) : (<></>)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="col-lg-4 col-sm-4 col-md-4">
                                                <strong>Tel&eacute;fono Personal</strong>
                                            </td>
                                            <td>
                                                <Form.Control
                                                    type="text"
                                                    size="sm"
                                                    autoComplete="off"
                                                    isInvalid={!!errors.vTelefonoPersonal}
                                                    {...register("vTelefonoPersonal",
                                                        {
                                                            required: 'Este campo es requerido, incluya el c\u00f3digo de pais: ejemplo: +52',
                                                            maxLength: 20,
                                                            minLength: 5,
                                                            pattern: {
                                                                value: /^[+][0-9]+$/,
                                                                message: "Tel\u00E9fono incorrecto. Debe iniciar con el prefijo: +"
                                                            }
                                                        })
                                                    }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.vTelefonoPersonal && errors.vTelefonoPersonal.message}
                                                </Form.Control.Feedback>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="col-lg-4 col-sm-4 col-md-4">
                                                <strong>Tel&eacute;fono Trabajo</strong>
                                            </td>
                                            <td>
                                                <Form.Control
                                                    type="text"
                                                    size="sm"
                                                    autoComplete="off"
                                                    isInvalid={!!errors.vTelefonoTrabajo}
                                                    {...register("vTelefonoTrabajo",
                                                        {
                                                            required: false,
                                                            maxLength: 20,
                                                            minLength: 5,
                                                            pattern: {
                                                                value: /^[+][0-9]+$/,
                                                                message: "Tel\u00E9fono incorrecto. Debe iniciar con el prefijo: +"
                                                            }
                                                        })
                                                    }
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="col-lg-4 col-sm-4 col-md-4"><strong>Pa&iacute;s</strong></td>
                                            <td>
                                                <Form.Select
                                                    size="sm"
                                                    aria-label="Default select"
                                                    isInvalid={!!errors.vPais}
                                                    {...register("vPais",
                                                        {
                                                            required: true
                                                        })
                                                    }
                                                    onChange={(event) => { mostrarEstados(event.target.value) }}
                                                >
                                                    <option value="">Selecciona un pa&iacute;s</option>
                                                    {countries.map((country, index) => {
                                                        return (<option key={index} value={country.vName}>{country.vName}</option>)
                                                    })}
                                                </Form.Select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="col-lg-4 col-sm-4 col-md-4"><strong>Estado/Provincia</strong></td>
                                            <td>
                                                {cargandoEstado ?
                                                    (
                                                        <h6>
                                                            <Spinner className="text-inline" size="sm" animation="border" variant="primary" /> Cargando...
                                                        </h6>
                                                    ) :
                                                    <Form.Select
                                                        size="sm"
                                                        aria-label="Default select"
                                                        defaultValue=""
                                                        isInvalid={!!errors.vEstadoDepProv}
                                                        {...register("vEstadoDepProv",
                                                            {
                                                                required: true
                                                            })
                                                        }
                                                    >
                                                        <option value="">Selecciona estado/provincia</option>
                                                        {states.map((st, index) => {
                                                            return (<option key={index} value={st.vName}>{st.vName}</option>)
                                                        })}
                                                    </Form.Select>}

                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>

                            </Card.Body>
                            <Card.Footer className="border-top text-end">

                            </Card.Footer>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <Card.Header className="p-2">
                                <h6 className="fw-semi-bold ls text-uppercase"> <FontAwesomeIcon icon="file" className="ms-2" />  INFORMACI&Oacute;N FISCAL</h6>
                            </Card.Header>
                            <Card.Body className="border-top">
                                <Table responsive striped size="sm" className="fs--1" >
                                    <tbody>
                                        {editar && (
                                            <>
                                                <tr>
                                                    <td colSpan={2}>
                                                        <div className="d-flex mb-0 align-items-center">
                                                            <ButtonGroup>
                                                                <ToggleButton
                                                                    type="radio"
                                                                    id="rdD_1"
                                                                    variant={'outline-success'}
                                                                    name="radioDist"
                                                                    value={true}
                                                                    checked={isDistribucion === true}
                                                                    size="sm"
                                                                    onChange={() => {
                                                                        setIsDistribucion(true);
                                                                    }}
                                                                >
                                                                    SI
                                                                </ToggleButton>

                                                                <ToggleButton
                                                                    type="radio"
                                                                    id="rdD_2"
                                                                    variant={'outline-danger'}
                                                                    name="radioDist"
                                                                    value={false}
                                                                    checked={isDistribucion === false}
                                                                    size="sm"
                                                                    onChange={() => {
                                                                        setIsDistribucion(false);
                                                                    }}
                                                                >
                                                                    NO
                                                                </ToggleButton>

                                                            </ButtonGroup>
                                                            <span className="mb-1 ms-1 fw-bold"> USAR INFORMACI&Oacute;N FISCAL DE DISTRIBUIDOR</span>
                                                        </div>
                                                        <hr className="mt-0"></hr>

                                                    </td>
                                                </tr>
                                                {isDistribucion &&
                                                    <>
                                                        <tr>
                                                            <td colSpan={2}>
                                                                <Select
                                                                    className="basic-single"
                                                                    closeMenuOnSelect={true}
                                                                    options={distribuidores}
                                                                    isSearchable={true}
                                                                    placeholder='Selecciona...'
                                                                    classNamePrefix="react-select"
                                                                    onChange={(e) => {
                                                                        setValue('vCp', e.vCp);
                                                                        setValue('vRfc', e.vRfc);
                                                                        setValue('vRazonSocial', e.vRazonSocial);
                                                                        setValue('idCatRegimenFiscal', e.idCatRegimenFiscal);
                                                                        setValue('vNumRegTrib', e.vNumRegTrib || '');
                                                                        setValue('vDireccionFiscal', e.vDireccionFiscal);
                                                                        setValue('idCatUsoCFDI', e.idCatUsoCFDI);
                                                                        setValue('vEmailFacturacion', e.vEmailFacturacion || '');
                                                                        setValue('vPaisFacturacion', e.vPaisFacturacion || '');
                                                                        setValue('vTelefonoFacturacion', e.vTelefonoFacturacion || '');
                                                                        
                                                                        // Detectar si es extranjero por el RFC
                                                                        if (e.vRfc === "XEXX010101000") {
                                                                            setIsExtranjero(true);
                                                                        } else {
                                                                            setIsExtranjero(false);
                                                                        }
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan={2}>
                                                                &nbsp;
                                                            </td>
                                                        </tr>
                                                    </>
                                                }
                                            </>
                                        )}
                                        <tr>
                                            <td className="col-lg-4 col-sm-4 col-md-4"><strong>RFC</strong></td>
                                            <td>
                                                <Form.Control
                                                    size="sm"
                                                    type="text"
                                                    autoComplete="off"
                                                    onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                    isInvalid={!!errors.vRfc}
                                                    {...register('vRfc',
                                                        {
                                                            required: 'El RFC es obligatorio',
                                                            maxLength: 13,
                                                            minLength: 12,
                                                            pattern: /^[A-ZÑ&]{3,4}\d{6}(?:[A-Z\d]{3})?$/
                                                        })
                                                    }
                                                    onChange={(event) => {
                                                        let rfc = (event.target.value).trim().toUpperCase();
                                                        if (rfc === "XEXX010101000" || rfc === "XAXX010101000") {
                                                            setValue('vCp', '61770');
                                                            setValue('idCatRegimenFiscal', 12);
                                                            setValue('idCatUsoCFDI', 22);
                                                        }
                                                        if (rfc === "XEXX010101000") {
                                                            setIsExtranjero(true);
                                                        } else {
                                                            setIsExtranjero(false);
                                                            setValue('vNumRegTrib', '');
                                                            setValue('vPaisFacturacion', '');
                                                        }
                                                    }}

                                                />
                                                {isExtranjero && (
                                                    <Form.Text className="text-muted">
                                                        RFC gen&eacute;rico para clientes extranjeros
                                                    </Form.Text>
                                                )}
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.vRfc && errors.vRfc.message}
                                                </Form.Control.Feedback>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="col-lg-4 col-sm-4 col-md-4"><strong>Raz&oacute;n Social</strong>
                                            </td>
                                            <td>
                                                <Form.Control
                                                    size="sm"
                                                    autoComplete="off"
                                                    type="text"
                                                    onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                    isInvalid={!!errors.vRazonSocial}
                                                    {...register('vRazonSocial',
                                                        {
                                                            required: 'La Raz\u00f3n Social es  obligatoria',
                                                            maxLength: 300,
                                                            minLength: 1,
                                                            pattern: /[^|]{1,300}/
                                                        })
                                                    }
                                                />
                                                <a href="#" onClick={() => { setValue("vRazonSocial", document.getElementById('vNombre').value + " " + document.getElementById('vApellidos').value) }}>Usar nombre y apellidos del cliente.</a>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.vRazonSocial && errors.vRazonSocial.message}
                                                </Form.Control.Feedback>
                                            </td>
                                        </tr>
                                       
                                        {isExtranjero && (
                                            <>
                                                <tr>
                                                    <td className="col-lg-4 col-sm-4 col-md-4">
                                                        <strong>Num. Reg. Trib.</strong>
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            size="sm"
                                                            type="text"
                                                            autoComplete="off"
                                                            onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                            isInvalid={!!errors.vNumRegTrib}
                                                            {...register('vNumRegTrib',
                                                                {
                                                                    maxLength: 40,
                                                                    minLength: 1
                                                                })
                                                            }
                                                        />
                                                        <Form.Text className="text-muted">
                                                            N&uacute;mero de identificaci&oacute;n fiscal del pa&iacute;s de origen
                                                        </Form.Text>
                                                        <Form.Control.Feedback type="invalid">
                                                            {errors.vNumRegTrib && errors.vNumRegTrib.message}
                                                        </Form.Control.Feedback>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="col-lg-4 col-sm-4 col-md-4">
                                                        <strong>Pa&iacute;s de Facturaci&oacute;n</strong>
                                                    </td>
                                                    <td>
                                                        <Form.Select
                                                            size="sm"
                                                            aria-label="Default select"
                                                            isInvalid={!!errors.vPaisFacturacion}
                                                            {...register("vPaisFacturacion",
                                                                {
                                                                    required: isExtranjero ? 'El pa\u00eds es obligatorio para clientes extranjeros' : false
                                                                })
                                                            }
                                                        >
                                                            <option value="">Selecciona un pa&iacute;s</option>
                                                            {codigosPaises.map((pais, index) => {
                                                                return (
                                                                    <option key={index} value={pais.cShortName}>
                                                                        {pais.cShortName} - {pais.vName}
                                                                    </option>
                                                                )
                                                            })}
                                                        </Form.Select>
                                                        <Form.Text className="text-muted">
                                                            Pa&iacute;s donde reside el cliente
                                                        </Form.Text>
                                                        <Form.Control.Feedback type="invalid">
                                                            {errors.vPaisFacturacion && errors.vPaisFacturacion.message}
                                                        </Form.Control.Feedback>
                                                    </td>
                                                </tr>
                                            </>
                                        )}
                                        <tr>
                                            <td className="col-lg-4 col-sm-4 col-md-4">
                                                <strong>Direcci&oacute;n Fiscal</strong>
                                            </td>
                                            <td>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    size="sm"
                                                    autoComplete="off"
                                                    onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                    isInvalid={!!errors.vDireccionFiscal}
                                                    {...register('vDireccionFiscal',
                                                        {
                                                            required: 'La direccion fiscal es obligatorio',
                                                            maxLength: 300,
                                                            minLength: 10
                                                        })
                                                    }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.vDireccionFiscal && errors.vDireccionFiscal.message}
                                                </Form.Control.Feedback>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="col-lg-4 col-sm-4 col-md-4">C&oacute;digo postal</td>
                                            <td>
                                                <Form.Control
                                                    size="sm"
                                                    type="number"
                                                    autoComplete="off"
                                                    isInvalid={!!errors.vCp}
                                                    {...register('vCp',
                                                        {
                                                            required: 'El Codigo postal es obligatorio',
                                                            maxLength: 6,
                                                            minLength: 4
                                                        })
                                                    }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.vCp && errors.vCp.message}
                                                </Form.Control.Feedback>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="col-lg-4 col-sm-4 col-md-4"><strong>R&eacute;gimen Fiscal</strong></td>
                                            <td>
                                                <Form.Select
                                                    size="sm"
                                                    aria-label="Default select"
                                                    isInvalid={!!errors.idCatRegimenFiscal}
                                                    {...register("idCatRegimenFiscal",
                                                        {
                                                            required: true
                                                        })
                                                    }
                                                >
                                                    <option value="">Selecciona un r&eacute;gimen</option>
                                                    {tablaRegimenFiscal.map((regimen, index) => {
                                                        return (
                                                            <option
                                                                key={index}
                                                                value={regimen.idCatRegimenFiscal}>
                                                                {regimen.vCodigoRegimen} - {regimen.vDescripcionRegimenFiscal}
                                                            </option>)
                                                    })}
                                                </Form.Select>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="col-lg-4 col-sm-4 col-md-4">
                                                <strong>Uso CFDI</strong>
                                            </td>
                                            <td>
                                                <Form.Select
                                                    size="sm"
                                                    aria-label="Default select"
                                                    isInvalid={!!errors.idCatUsoCFDI}
                                                    {...register("idCatUsoCFDI",
                                                        {
                                                            required: true
                                                        })
                                                    }
                                                >
                                                    <option value="">Selecciona un uso de CFDI</option>
                                                    {tablaUsoCFDI.map((uso, index) => {
                                                        return (
                                                            <option
                                                                key={index}
                                                                value={uso.idCatUsoCFDI}>
                                                                {uso.vCodigoUso} - {uso.vDescripcionUsoCFDI}
                                                            </option>)
                                                    })}
                                                </Form.Select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td> <strong>Correo de Facturaci&oacute;n </strong></td>
                                            <td>
                                                <Form.Control
                                                    type="text"
                                                    size="sm"
                                                    autoComplete="off"
                                                    isInvalid={!!errors.vEmailFacturacion}
                                                    {...register("vEmailFacturacion",
                                                        {
                                                            maxLength: 120,
                                                            minLength: 5,
                                                            pattern: {
                                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                                message: "Email incorrecto."
                                                            }
                                                        })
                                                    }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.vEmailFacturacion && errors.vEmailFacturacion.message}
                                                </Form.Control.Feedback>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="col-lg-4 col-sm-4 col-md-4">
                                                <strong>Tel&eacute;fono de Facturaci&oacute;n</strong>
                                            </td>
                                            <td>
                                                <Form.Control
                                                    type="text"
                                                    size="sm"
                                                    autoComplete="off"
                                                    isInvalid={!!errors.vTelefonoFacturacion}
                                                    {...register("vTelefonoFacturacion",
                                                        {
                                                            required: false,
                                                            maxLength: 20,
                                                            minLength: 5,
                                                            pattern: {
                                                                value: /^[+][0-9]+$/,
                                                                message: "Tel\u00E9fono incorrecto. Incluya el c\u00f3digo de pais: ejemplo: +52 "
                                                            }
                                                        })
                                                    }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.vTelefonoFacturacion && errors.vTelefonoFacturacion.message}
                                                </Form.Control.Feedback>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Card.Body>
                            <Card.Footer className="border-top text-end">
                                {editar &&
                                    <IconButton
                                        className="ms-2"
                                        iconClassName="fs--2 me-1"
                                        variant="falcon-default"
                                        size="sm"
                                        icon="check"
                                        type="submit"
                                    >
                                        Guardar Cambios
                                    </IconButton>
                                }
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
            </Form>
        </>
    );
};

export default NuevoCliente;
